// src/store/index.js

// 1. استيراد الـ store والـ persistor من ملف store.js
import store, { persistor } from "./store";

// 2. تصدير الـ store كافتراضي (ليعمل import store from './store')
export default store;

// 3. تصديرهم معاً كتصدير مسمى (ليعمل import { store, persistor } from './store')
export { store, persistor };

// ----------------------------------------------------------------------
// باقي التصديرات الخاصة بك تبقى كما هي بدون أي تغيير
// ----------------------------------------------------------------------

// selectors
export {
  selectForm,
  selectInfo,
  selectCriteria,
  selectEvaluations,
  selectLessons,
  selectCurrentLessonNo,
} from "./selectors";

// actions
export {
  setInfoField,
  setAxis,
  loadStudents,
  updateAxisRating,
  updateAxisNote,
  hydrateLessonsFromStorage,
  goToNextLesson,
  clearFormValues,
} from "./formSlice";

export * from "./settingsSlice";